import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=6b125062&scoped=true&"
import script from "./Archives.vue?vue&type=script&lang=ts&"
export * from "./Archives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b125062",
  null
  
)

export default component.exports